import PropTypes from 'prop-types';
import React from 'react';
import { openStagesFor, getStageBadgeConfig } from '../../Deals/components/dealStages';

const WON_TERMINAL_STAGES = ['closed_won', 'stewardship'];
const LOST_TERMINAL_STAGES = ['closed_lost', 'not_a_prospect'];

function StageProgressBar({ dealType, stage }) {
  const openStages = openStagesFor(dealType);
  const isWon = WON_TERMINAL_STAGES.includes(stage);
  const isLost = LOST_TERMINAL_STAGES.includes(stage);
  const terminal = isWon || isLost ? stage : 'closed_won';
  const steps = [...openStages, terminal];
  const currentIndex = isWon || isLost ? steps.length - 1 : openStages.indexOf(stage);

  return (
    <div className="deal-progress" role="list" aria-label="Deal stage progress">
      {steps.map((step, index) => {
        const isTerminal = index === steps.length - 1;
        const lost = isLost && isTerminal;
        const complete = !isLost && index <= currentIndex;
        const current = index === currentIndex;
        return (
          <div
            key={step}
            role="listitem"
            aria-current={current ? 'step' : undefined}
            className={`deal-progress-step${complete ? ' is-complete' : ''}${current ? ' is-current' : ''}${lost ? ' is-lost' : ''}`}
          >
            <span className="deal-progress-bar" />
            <span className="deal-progress-label">{getStageBadgeConfig(step).label}</span>
          </div>
        );
      })}
    </div>
  );
}

StageProgressBar.propTypes = {
  dealType: PropTypes.string,
  stage: PropTypes.string,
};

export default StageProgressBar;
